import axios from "axios"
import {getConfig} from "./utility";

const initialState = {
    overview: {overview: [], customers:[], type:[]},
    overviewLoader: false,
    selection: {selectionDetails: {groups: []}, selectionGroupCreationData: {persType: [], education: [], persSuperSpc: [], siteType: [], posistion: [], workingSpec: [], siteSpec: []}},
    selectionLoader: false,
    loadSelectionsAfter: [],
    updateSelections: [],
    populate: [],
    selectionRowUpdate: []
};

const OVERVIEW_GET = "OVERVIEW_GET";
const OVERVIEW_GET_CREATE = "OVERVIEW_GET_CREATE";
const SELECTION_GET = "SELECTION_GET";
const SELECTION_INSERT = "SELECTION_INSERT";
const SELECTION_DEACTIVATE = "SELECTION_DEACTIVATE";
const SELECTIONGROUP_INSERT = "SELECTIONGROUP_INSERT";
const SELECTIONGROUP_UPDATE = "SELECTIONGROUP_UPDATE";
const SELECTIONROW_UPDATE = "SELECTIONROW_UPDATE";

export default (state = initialState, action) => {
    switch (action.type) {
        case OVERVIEW_GET:
            switch (action.status) {
                case 0:
                    return {...state, overviewLoader: true};
                case 1:
                    return {...state, overview: action.overview, overviewLoader: false};
                default:
                    return {...state, overviewLoader: false};
            }

        case OVERVIEW_GET_CREATE:
            switch (action.status) {
                case 0:
                    return {...state};
                case 1:
                    return {...state, overview: action.populate};
                default:
                    return {...state};
            }

        case SELECTION_GET:
            switch (action.status) {
                case 0:
                    return {...state, selectionLoader: true};
                case 1:
                    return {...state, selection: action.selection, selectionLoader: false};
                default:
                    return {...state, selectionLoader: false};
            }

        case SELECTION_INSERT:
            switch (action.status) {
                case 0:
                    return {...state, overviewLoader: true};
                case 1:
                    return {...state, selection: action.selection, selectionLoader: false};
                default:
                    return {...state, overviewLoader:true};
            }

        case SELECTION_DEACTIVATE:
            switch (action.status) {
                case 0:
                    return {...state, overviewLoader: true};
                case 1:
                    return {...state, overview: action.overview, overviewLoader: false};
                default:
                    return {...state, overviewLoader:true};
            }

        case SELECTIONGROUP_UPDATE:
            switch (action.status) {
                case 0:
                    return {...state, selectionLoader: true};
                case 1:
                    return {...state, selection: action.selection};
                default:
                    return {...state, selectionLoader: false};
            }


        case SELECTIONGROUP_INSERT:
            switch (action.status) {
                case 0:
                    return {...state, selectionLoader: true};
                case 1:
                    return {...state, selection: action.selection, selectionLoader: false};
                default:
                    return {...state, selectionLoader: false};
            }

        case SELECTIONROW_UPDATE:
            switch (action.status) {
                case 0:
                    return {...state};
                case 1:
                    return {...state, selectionRowUpdate: action.selectionRowUpdate};
                default:
                    return {...state};
            }



        default:
            return state
    }
}


const getOverviewReq = () => ({type: OVERVIEW_GET, status: 0})
const getOverviewSuc = overview => ({type: OVERVIEW_GET, status: 1, overview})
const getOverviewErr = error => ({type: OVERVIEW_GET, status: -1, error})
export const getOverview = () => (dispatch, getState) => {
    dispatch(getOverviewReq())
    return axios
        .get('/selection/builder', getConfig(getState))
        .then(res => dispatch(getOverviewSuc(res.data)))
        .catch(err => dispatch(getOverviewErr(err)));
};

const getOverviewCreateReq = (request) => ({type: OVERVIEW_GET, status: 0, request})
const getOverviewCreateSuc = overview => ({type: OVERVIEW_GET, status: 1, overview})
const getOverviewCreateErr = error => ({type: OVERVIEW_GET, status: -1, error})
export const getOverviewCreate = (request) => (dispatch, getState) => {
    dispatch(getOverviewCreateReq(request))
    return axios.post(`/selection/builder/createSelection`, request, getConfig(getState))
        .then(res => dispatch(getOverviewCreateSuc(res.data)))
        .catch(err => dispatch(getOverviewCreateErr(err)));
};


const getSelectionsReq = (id) => ({type: SELECTION_GET, status: 0, id});
const getSelectionsRec = selection => ({type: SELECTION_GET, status: 1, selection});
const getSelectionsErr = error => ({type: SELECTION_GET, status: -1, error});
export const getSelections = (id) => (dispatch, getState) => {
    console.log('get selections');
    dispatch(getSelectionsReq(id));
    return axios.get(`/selection/builder/${id}`, getConfig(getState))
        .then(res => dispatch(getSelectionsRec(res.data)))
        .catch(err => dispatch(getSelectionsErr(err)))
};

const insertSelectionsReq = (request, id) => ({type: SELECTION_INSERT, status: 0, request, id});
const insertSelectionsRec = overview => ({type: SELECTION_INSERT, status: 1, overview});
const insertSelectionsErr = error => ({type: SELECTION_INSERT, status: -1, error});
export const insertSelections = (request, id) => (dispatch, getState) => {
    dispatch(insertSelectionsRec(request, id));
    return axios.post(`/selection/builder/${id}/insert`, request, getConfig(getState))
        .then(res => dispatch(insertSelectionsReq(res.data)))
        .catch(err => dispatch(insertSelectionsErr(err)))
};

const deactivateSelectionsReq = (id, activeId) => ({type: SELECTION_DEACTIVATE, status: 0, id, activeId});
const deactivateSelectionsRec = overview => ({type: SELECTION_DEACTIVATE, status: 1, overview});
const deactivateSelectionsErr = error => ({type: SELECTION_DEACTIVATE, status: -1, error});
export const deactivateSelection = (id, activeId) => (dispatch, getState) => {
    dispatch(deactivateSelectionsReq(id, activeId));
    return axios.get(`/selection/builder/${id}/${activeId}/deactivate`, getConfig(getState))
        .then(res => dispatch(deactivateSelectionsRec(res.data)))
        .catch(err => dispatch(deactivateSelectionsErr(err)))
};

const insertGroupSelectionsReq = (request, id, groupId) => ({type: SELECTIONGROUP_INSERT, status: 0, request, id, groupId});
const insertGroupSelectionsRec = selection => ({type: SELECTIONGROUP_INSERT, status: 1, selection});
const insertGroupSelectionsErr = error => ({type: SELECTIONGROUP_INSERT, status: -1, error});
export const insertGroupSelections = (request, id, groupId) => (dispatch, getState) => {
    dispatch(insertGroupSelectionsReq(request, id, groupId));
    return axios.post(`/selection/builder/${id}/${groupId}/group`, request, getConfig(getState))
        .then(res => dispatch(insertGroupSelectionsRec(res.data)))
        .catch(err => dispatch(insertGroupSelectionsErr(err)))
};

const createGroupSelectionsReq = (request, id) => ({type: SELECTION_GET, status: 0, request, id});
const createGroupSelectionsRec = selection => ({type: SELECTION_GET, status: 1, selection});
const createGroupSelectionsErr = error => ({type: SELECTION_GET, status: -1, error});
export const createGroupSelections = (request, id) => (dispatch, getState) => {
    dispatch(createGroupSelectionsReq(request, id));
    return axios.post(`/selection/builder/${id}/createSelection`, request, getConfig(getState))
        .then(res => dispatch(createGroupSelectionsRec(res.data)))
        .catch(err => dispatch(createGroupSelectionsErr(err)))
};


const updateGroupSelectionsReq = (request, id) => ({type: SELECTION_GET, status: 0, request, id});
const updateGroupSelectionsRec = selection => ({type: SELECTION_GET, status: 1, selection});
const updateGroupSelectionsErr = error => ({type: SELECTION_GET, status: -1, error});
export const updateGroupSelections = (request, id) => (dispatch, getState) => {
    dispatch(updateGroupSelectionsReq(request, id));
    return axios.post(`/selection/builder/${id}/update`, request, getConfig(getState))
        .then(res => dispatch(updateGroupSelectionsRec(res.data)))
        .catch(err => dispatch(updateGroupSelectionsErr(err)))
};

const getUpdateRowSelectionsReq = (id) => ({type: SELECTION_GET, status: 0, id});
const getUpdateRowSelectionsRec = selectionRowUpdate => ({type: SELECTION_GET, status: 1, selectionRowUpdate});
const getUpdateRowSelectionsErr = error => ({type: SELECTION_GET, status: -1, error});
export const updateRowSelections = (id) => (dispatch, getState) => {
    dispatch(getUpdateRowSelectionsReq(id));
    return axios.get(`/selection/builder/${id}/updateRow`, getConfig(getState))
        .then(res => dispatch(getUpdateRowSelectionsRec(res.data)))
        .catch(err => dispatch(getUpdateRowSelectionsErr(err)))
};

const updateelectionsReq = (request, id) => ({type: SELECTIONGROUP_INSERT, status: 0, request, id});
const updateSelectionsRec = selection => ({type: SELECTIONGROUP_INSERT, status: 1, selection});
const updateSelectionsErr = error => ({type: SELECTIONGROUP_INSERT, status: -1, error});
export const updateSelections = (request, id) => (dispatch, getState) => {
    dispatch(updateelectionsReq(request, id));
    return axios.post(`/selection/builder/${id}/selectionUpdate`, request, getConfig(getState))
        .then(res => dispatch(updateSelectionsRec(res.data)))
        .catch(err => dispatch(updateSelectionsErr(err)))
};

const updateSlectionRowReq = (request, id) => ({type: SELECTIONGROUP_INSERT, status: 0, request, id});
const updateSlectionRowRec = selection => ({type: SELECTIONGROUP_INSERT, status: 1, selection});
const updateSlectionRowErr = error => ({type: SELECTIONGROUP_INSERT, status: -1, error});
export const updateSlectionRow = (request, id) => (dispatch, getState) => {
    dispatch(updateSlectionRowReq(request, id));
    return axios.post(`/selection/builder/${id}/update/row`, request, getConfig(getState))
        .then(res => dispatch(updateSlectionRowRec(res.data)))
        .catch(err => dispatch(updateSlectionRowErr(err)))
};




// WEBPACK FOOTER //
// ./src/js/reducers/selection_builder.js